import { render, staticRenderFns } from "./soundWave.vue?vue&type=template&id=36edb4f1&scoped=true"
import script from "./soundWave.vue?vue&type=script&lang=js"
export * from "./soundWave.vue?vue&type=script&lang=js"
import style0 from "./soundWave.vue?vue&type=style&index=0&id=36edb4f1&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36edb4f1",
  null
  
)

export default component.exports